import { Flex, FlexProps, Text } from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'

import EmptyIcon from '@/ui/assets/EmptyIcon'

export default function EmptyComponent(
  props: FlexProps & {
    message?: string
    iconWidth?: string
    iconHeight?: string
    textWidth?: string
    fontSize?: string
    height?: string
  }
) {
  const { t } = useTranslation()
  const {
    message,
    iconWidth,
    iconHeight,
    textWidth,
    fontSize,
    height,
    ...rest
  } = props

  return (
    <Flex
      h={height ?? '60vh'}
      flexDir={'column'}
      align={'center'}
      justifyContent={'space-around'}
      {...rest}
    >
      <EmptyIcon w={iconWidth ?? '20rem'} h={iconHeight ?? '16rem'} />
      <Text
        w={textWidth ?? '50%'}
        textStyle={'h2'}
        fontSize={fontSize ?? '2rem'}
        textAlign={'center'}
      >
        {message ?? t('general.common.empty.message')}
      </Text>
    </Flex>
  )
}
